import { functions } from '@src/firebase/firebase';

const FUNCTIONS_REGION = 'us-central1';
const FUNCTIONS_EMULATOR_PORT = 5001;

interface RestEndpointRuntime {
  projectId?: string;
  hostname?: string;
  useEmulator?: boolean;
}

type RestQuery = Record<string, string>;

const getDefaultRuntime = (): RestEndpointRuntime => ({
  projectId: functions.app.options.projectId,
  hostname: typeof window === 'undefined' ? 'localhost' : window.location.hostname,
  useEmulator:
    process.env.NODE_ENV !== 'production' && process.env.REACT_APP_USE_EMULATORS === 'true',
});

export const buildRestUrl = (
  path: `/${string}`,
  query?: RestQuery,
  runtime: RestEndpointRuntime = getDefaultRuntime(),
): string => {
  if (!runtime.projectId) {
    throw new Error('Firebase project ID is required to build a REST endpoint');
  }

  const origin = runtime.useEmulator
    ? `http://${runtime.hostname ?? 'localhost'}:${FUNCTIONS_EMULATOR_PORT}`
    : `https://${FUNCTIONS_REGION}-${runtime.projectId}.cloudfunctions.net`;
  const url = new URL(origin);
  url.pathname = runtime.useEmulator
    ? `/${runtime.projectId}/${FUNCTIONS_REGION}/rest${path}`
    : `/rest${path}`;

  Object.entries(query ?? {}).forEach(([key, value]) => {
    url.searchParams.set(key, value);
  });

  return url.toString();
};
